import { memo, FC } from 'react';
import { Box, Checkbox, Grid, GridItem } from '@chakra-ui/react';

import { TextWithTooltip } from 'components/molecules/TextWithTooltip/TextWithTooltip';
import { CustomerForNotification } from 'types/customer';

type Props = {
  /** 顧客情報 */
  item: CustomerForNotification;
  /** 選択フラグ */
  isSelected: boolean;
  /** Checkbox 変更イベントのハンドラ */
  handleCheckboxChange: () => void;
  /** 行クリックイベントのハンドラ */
  handleCustomerClick: () => void;
};

export const CustomerListItem: FC<Props> = memo(
  ({ item, isSelected, handleCheckboxChange, handleCustomerClick }) => {
    const bgColor = isSelected ? 'gray.50' : 'secondaryList.item.bgColor';

    return (
      <Box
        m={0}
        h="40px"
        w="100%"
        textAlign="start"
        color="secondaryList.item.color"
        border="none"
        backgroundColor={bgColor}
        _hover={{
          background: 'gray.100',
        }}
        _active={{
          background: 'gray.200',
        }}
        borderBottom="1px"
        borderBottomColor="secondaryList.item.borderColor"
      >
        <Grid
          h="100%"
          templateColumns="1fr 30fr" // チェックボックスとそれ以外
          gap={0}
          justifyItems="start"
          alignItems="center"
        >
          {/* チェックボックス */}
          <GridItem h="100%" justifySelf="center" alignSelf="center">
            <Checkbox
              h="100%"
              isChecked={isSelected}
              onChange={handleCheckboxChange}
            />
          </GridItem>
          {/* それ以外（クリッカブルな ID, 顧客名，顧客詳細） */}
          <GridItem h="100%" w="100%">
            <Box
              as="button"
              m={0}
              h="100%"
              w="100%"
              textAlign="start"
              cursor="pointer"
              onClick={handleCustomerClick}
            >
              <Grid
                templateColumns="4fr 10fr 15fr"
                gap={0}
                justifyItems="start"
                alignItems="center"
              >
                <GridItem justifySelf="end" pr="20px">
                  <TextWithTooltip text={item.id.toString()} />
                </GridItem>
                <GridItem pl="20px">
                  <TextWithTooltip text={item.name} />
                </GridItem>
                <GridItem pl="20px">
                  <TextWithTooltip
                    text={item.detail}
                    textMaxWidth="200px"
                    visibleTooltip
                    tooltipMaxWidth="300px"
                  />
                </GridItem>
              </Grid>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    );
  },
);
